
import { Route } from '@/app/router'

const Home = () => import('./index.vue')

const HomeMeta = {
	sort: 1,
	displayInSidebar: true,
	displayName: 'home',
	icon: 'fal home',
	activeIcon: 'fas home',
	title: 'Recar - Pradžia'
}

export default new Route('/home', Home).as('Dashboard:Home').meta(HomeMeta)
